import { COMMERCE_CATEGORY } from "~/constants";

export const priorityMap = {
  [COMMERCE_CATEGORY.FREE]: 5,
  [COMMERCE_CATEGORY.MEMBER]: 4,
  [COMMERCE_CATEGORY.PPV]: 3,
  [COMMERCE_CATEGORY.TRANSACTIONAL]: 2,
  [COMMERCE_CATEGORY.SUBSCRIPTION]: 1,
};

export const getCommerceCategory = (commerce_types?: TCommerceCategory[]): TCommerceCategory => {
  if (!commerce_types || commerce_types.length === 0)
    return COMMERCE_CATEGORY.FREE;

  let highestPriorityType: TCommerceCategory = commerce_types[0];

  for (const commerce_type of commerce_types) {
    if (priorityMap[commerce_type] > priorityMap[highestPriorityType])
      highestPriorityType = commerce_type;
  }

  return highestPriorityType;
};

export function getCallbackCommerceUrl(
  params: Record<string, string>,
): string {
  const baseURL = "/payment/processing/";
  const url = new URL(baseURL, window.location.origin);

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });

  return url.toString();
}
